(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockBausteinAuswahlUebersicht', {
            require: {
                form: '^?form'
            },
            bindings: {
                produktgruppen: '<abbauProduktgruppen',
                bausteineBeitrag: '<abbauBausteineBeitrag',
                changeGegenstand: '&?abbauChangeGegenstand',
                options: '<abbauOptions'
            },
            templateUrl: 'bloecke/ergebnis/blockBausteinAuswahlUebersicht.html',
            controller: BlockBausteinAuswahlUebersichtController,
            controllerAs: 'blockBausteinAuswahlUebersichtVm'
        });

    BlockBausteinAuswahlUebersichtController.$inject = [
        'lodash',
        'AppConfig'
    ];
    function BlockBausteinAuswahlUebersichtController(_, AppConfig) {
        var vm = this,
            zahlweiseTextMap;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.getLabel = getLabel;
        vm.getBeitrag = getBeitrag;
        vm.isGegenstandAuswahlDisabled = isGegenstandAuswahlDisabled;
        vm.isGegenstandAuswahlRequired = isGegenstandAuswahlRequired;

        function activate() {
            vm.options = vm.options || {};
            zahlweiseTextMap = AppConfig.ANGEBOT.zahlweiseText;
            vm.bausteineBeitragToBaustein = {};
            vm.bausteineBeitragToGegenstand = {};

            vm.bausteineBeitrag = vm.bausteineBeitrag || {};

            vm.gridLayoutCss = vm.options.grid || {};
            vm.options.currency = vm.options.currency || 'symbol';

            if (!vm.gridLayoutCss.columnLeft) {
                vm.gridLayoutCss.columnLeft = 'small-12 medium-9';
            }

            if (!vm.gridLayoutCss.columnRight) {
                vm.gridLayoutCss.columnRight = 'small-12 medium-3';
            }

            _.forEach(vm.produktgruppen, function (produktGruppe) {
                vm.bausteineBeitragToBaustein[produktGruppe] = _.filter(vm.bausteineBeitrag[produktGruppe], function (bausteinBeitrag) {
                    if (!bausteinBeitrag.gegenstand) {
                        return bausteinBeitrag;
                    }
                });

                vm.bausteineBeitragToGegenstand[produktGruppe] = [];

                _.forEach(_.filter(vm.bausteineBeitrag[produktGruppe], function (bausteinBeitrag) {
                    if (bausteinBeitrag.gegenstand) {
                        return bausteinBeitrag;
                    }
                }), function (bausteinBeitrag) {
                    var gegenstand = _.find(vm.bausteineBeitragToGegenstand[produktGruppe], function (obj) {
                        return (
                            _.get(obj, 'gegenstand.id') === _.get(bausteinBeitrag, 'gegenstand.id') &&
                            obj.key === bausteinBeitrag.gegenstandKey
                        );
                    });

                    if (gegenstand) {
                        gegenstand.bausteine.push(bausteinBeitrag);
                    } else {
                        vm.bausteineBeitragToGegenstand[produktGruppe].push({
                            gegenstand: _.get(bausteinBeitrag, 'gegenstand'),
                            key: _.get(bausteinBeitrag, 'gegenstandKey'),
                            infos: _.get(bausteinBeitrag, 'gegenstandInfos'),
                            bausteine: [bausteinBeitrag]
                        });
                    }
                });
            });
        }

        function onChanges() {
            activate();
        }

        function onInit() {
            activate();
        }
        function getLabel(bausteinBeitrag) {
            return _.compact([
                _.get(bausteinBeitrag, 'infos.label.deckung'),
                _.get(bausteinBeitrag, 'infos.label.zusatz')
            ]).join('<br>');
        }
        function getBeitrag(bausteinBeitrag) {
            var beitrag,
                bausteinTarifart;

            if (bausteinBeitrag && bausteinBeitrag.baustein && _.get(bausteinBeitrag.baustein, 'tarifartModellierung.wert')) {
                bausteinTarifart = _.get(bausteinBeitrag.baustein, 'tarifartModellierung.wert');
                beitrag = _.get(bausteinBeitrag, 'beitrag[' + bausteinTarifart + ']');
            } else {
                beitrag = _.get(bausteinBeitrag, 'beitrag');
            }
            return {
                beitrag: _.get(beitrag, 'brutto'),
                zahlweiseText: zahlweiseTextMap[_.get(beitrag, 'zahlweise.wert')]
            };
        }

        function isGegenstandAuswahlDisabled(gegenstand) {
            var anzahlAktiveGegenstande = 0;

            _.forEach(vm.produktgruppen, function (produktGruppe) {
                anzahlAktiveGegenstande += _.size(_.filter(vm.bausteineBeitragToGegenstand[produktGruppe], function (obj) {
                    return _.get(obj, 'gegenstand.aktiv') === true;
                }));
            });

            return (
                vm.options.disabled ||
                (
                    gegenstand.aktiv &&
                    anzahlAktiveGegenstande <= 1
                )
            );
        }

        function isGegenstandAuswahlRequired(gegenstand) {
            var anzahlAktiveGegenstande = 0;

            _.forEach(vm.produktgruppen, function (produktGruppe) {
                anzahlAktiveGegenstande += _.size(_.filter(vm.bausteineBeitragToGegenstand[produktGruppe], function (obj) {
                    return _.get(obj, 'gegenstand.aktiv') === true;
                }));
            });

            return (
                !vm.options.disabled &&
                anzahlAktiveGegenstande < 1
            );
        }
    }

})();
